import * as actions from "store/actions/mei/create";
import IMei from "Types/IMei";
import dayjs from "dayjs";

export interface MeiCreateState extends IMei {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: MeiCreateState = {
	logisticOperator: undefined,
	logisticOperatorStatus: 1,
	loading: false,
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.CREATE_MEI: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_MEI_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_MEI_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
